/**
 * Created by tofael on 9/3/18.
 */
import React, { Component } from 'react';

class ImageViewer extends Component {
  constructor() {
    super(...arguments);
    this.state = {
      src: ''
    };
  }

  componentDidMount(){
    this.loadImage();
  }

  loadImage(){
    const file = this.props.file;

    if (typeof file === 'string' || file instanceof String){
      this.setState({src: file});
    } else {
      const reader = new FileReader();
      reader.onload = (e)=>{
        const src = e.target.result;
        this.setState({src});
      };
      reader.readAsDataURL(file);
    }
  }

  render() {
    const { src } = this.state;
    return (
      <img src={src} height = '750px' width='100%' alt="preview" />
    );
  }
}

export default ImageViewer;


// WEBPACK FOOTER //
// ./src/screens/shared/file-upload/preview/image-viewer.js